<script>
import Layout from "../../layouts/main";
import ZoneComponent from "../zone/zone-component.vue";
import ImportParnterList from "../partner/import-partners-list.vue";


export default {
  name: 'MyMapComponent',
  components: {Layout , ZoneComponent, ImportParnterList},
  data() {
    return {
     
    };
  },

  
};
</script>

<template>
  <Layout>
    <div class="card mr-sm-5 ml-sm-5">
      <div class="card-body">

        <div class="row">
          <div class="col-md-8 col-12">
            <h4 class="card-title mb-4 text-uppercase font-weight-bold text-dark" style="font-size: 25px;">{{$t("zone.cards.cardTitle")}} </h4>
          </div>

          <div class="col-md-4 col-12">
            <router-link  :to="{ path: '/partenaire' }"  >
              <b-button variant="primary" class="mb-4 float-right">
                  <span class=" text-uppercase font-weight-bold">
                      {{$t('partner.text.newPartner')}}
                  </span>
              </b-button>
            </router-link>   
          </div>
        </div>

          <!-- <b-tabs  nav-class="nav-tabs-custom" content-class="p-sm-3 p-0 mt-sm-0 mt-3 text-muted" active-nav-item-class="font-weight-bold text-uppercase ">
            <b-tab  active class="border-0"  lazy @click="activeTab=0">
              <template v-slot:title>
                  <img alt="View details" width="20px" fill="#fff" src="@/assets/icons/map.svg" style="cursor: pointer; margin-right: 10px;"/>
                  <span class="d-none d-sm-inline-block font-size-16">{{ $t('zone.tabs.tab1') }} </span>
              </template> -->
            
              <ZoneComponent class="mt-4"></ZoneComponent>

              <ImportParnterList/>


            <!-- </b-tab> -->

            <!-- <b-tab   class="border-0"  lazy @click="activeTab=1">
              <template v-slot:title>
                  <img  alt="View details"  width="20px"  src="@/assets/icons/users.svg" style="cursor: pointer; margin-right: 10px;"  />
                  <span class="d-none d-sm-inline-block font-size-16">{{ $t('zone.tabs.tab2') }} </span>
              </template>
              <parnter></parnter>
            </b-tab>
            
          </b-tabs> -->

      </div>
    </div>
  </Layout>
</template>
